import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "../../lib/anim";
import { GyroOrb } from "./Instrument";

const WORDS =
  "Per noi il volo rappresenta molto più di un settore. Rappresenta un modo di pensare.".split(
    " "
  );

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "start 0.2"] });

  return (
    <section
      id="manifesto"
      ref={ref}
      className="relative bg-[#060607] py-32 sm:py-44 lg:py-56"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-4 mb-16">
          <span className="font-mono-x text-[11px] tracking-[0.3em] text-white/30">01</span>
          <span className="h-px w-10 bg-white/15" />
          <span className="eyebrow">Manifesto</span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 1.1, ease: EASE }}
          className="font-display font-semibold text-white leading-[0.9] tracking-tight text-[16vw] sm:text-[12vw] lg:text-[9vw]"
        >
          Una mentalità<br />
          <span className="stroke-text">che guarda oltre.</span>
        </motion.h2>

        <div className="relative mt-20 lg:mt-28">
          <GyroOrb className="hidden lg:block absolute left-[2%] top-1/2 -translate-y-1/2 w-[30%] max-w-[340px] pointer-events-none" />
          <div className="lg:pl-[40%]">
          <p className="font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.35] tracking-tight flex flex-wrap gap-x-[0.28em] gap-y-1">
            {WORDS.map((w, i) => {
              const start = i / WORDS.length;
              const end = start + 1 / WORDS.length;
              return <Word key={i} progress={scrollYProgress} range={[start, end]} word={w} />;
            })}
          </p>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1, ease: EASE }}
            className="mt-12 max-w-lg text-base sm:text-lg text-white/45 leading-relaxed"
          >
            Ogni decollo nasce dalla preparazione. Ogni decisione richiede responsabilità. Ogni
            dettaglio può fare la differenza. Sono gli stessi principi che guidano ogni brand
            sviluppato da MGB Aviation, con la convinzione che costruire un'impresa significhi
            creare qualcosa destinato a durare.
          </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

const Word = ({ progress, range, word }) => {
  const opacity = useTransform(progress, range, [0.14, 1]);
  return (
    <span className="relative">
      <motion.span style={{ opacity }} className="text-white">
        {word}
      </motion.span>
    </span>
  );
};
